export const THEME_GENERATE_ASSIST_QUERY_KEY = "assist";
export const THEME_GENERATE_ASSIST_QUERY_VALUE = "generate-theme";

type RouteQueryValue = string | (string | null)[];
type RouteQuery = Record<string, RouteQueryValue>;

export function createThemeGenerateRedirectLocation(novelId: string) {
  return {
    name: "theme",
    params: { novelId },
    query: {
      [THEME_GENERATE_ASSIST_QUERY_KEY]: THEME_GENERATE_ASSIST_QUERY_VALUE,
    },
  };
}

export function isThemeGenerateRedirectRequested(query: RouteQuery | null | undefined): boolean {
  return query?.[THEME_GENERATE_ASSIST_QUERY_KEY] === THEME_GENERATE_ASSIST_QUERY_VALUE;
}

export function removeThemeGenerateRedirectQuery(query: RouteQuery | null | undefined): RouteQuery {
  const nextQuery = { ...query };
  delete nextQuery[THEME_GENERATE_ASSIST_QUERY_KEY];
  return nextQuery;
}
